exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n\n\n\n\n\n\n/* main */\n.ui-search {\n    height: 34px;\n}\n.ui-search svg {\n    width: 20px;\n    height: 20px;\n    margin-left: 6px;\n}\n.ui-search input {\n    height: 100%;\n    padding-left: 6px;\n}\n\n\n", ""]);
